export const events = {
  OnboardingEmailVerificationPageVisited: 'Onboarding - Email Verification Page- Visited',
  OnboardingEmailVerificationPageSent: 'Onboarding - Email Verification Page - Submitted',
  OnboardingEmailVerificationPageResend: 'Email Verification Page - Resend',
};
